import { api } from '@smena/ui';

export interface BookingSummary {
  id: string;
  guestName: string;
  guestPhone: string | null;
  checkin: string;
  checkout: string;
  nights: number;
  amount: number;
  prepaid: boolean;
  status: string;
  source: string;
  propertyId: string;
  createdAt: string;
  inviteStatus: 'not_invited' | 'invited' | 'joined' | 'active';
  sessionCount: number;
  lastActivityAt: string | null;
}

export interface WelcomeChannel {
  kind: 'telegram' | 'webchat' | 'sms' | 'email';
  label: string;
  enabled: boolean;
  text: string;
  url?: string;
  subject?: string;
  note?: string;
}

export interface InvitePackage {
  token: string;
  url: string;
  accessCode: string | null;
  channels: WelcomeChannel[];
  booking: BookingSummary;
}

export async function fetchBookings(): Promise<BookingSummary[]> {
  const r = await api<{ bookings: BookingSummary[] }>('/api/staff/bookings');
  return r.bookings;
}

export async function fetchBooking(id: string): Promise<BookingSummary> {
  const r = await api<{ booking: BookingSummary }>(`/api/staff/bookings/${id}`);
  return r.booking;
}

export async function invite(id: string): Promise<InvitePackage> {
  return api<InvitePackage>(`/api/staff/bookings/${id}/invite`, { method: 'POST', json: {} });
}

export async function togglePrepaid(id: string, prepaid: boolean): Promise<{ prepaid: boolean }> {
  return api<{ prepaid: boolean }>(`/api/staff/bookings/${id}/toggle-prepaid`, {
    method: 'POST',
    json: { prepaid },
  });
}
